const headRowsTableMaintenances = {
  id: 'ID',
  equipment: 'Equipment',
  createdAt: 'Created At',
  sendToMaintenanceDate: 'Send To Maintenance Date',
  returnFromMaintenanceDate: 'Return From Maintenance Date',
  warrantyDate: 'Warranty Deadline',
  expirationDate: 'Expiration Deadline',
  place: 'Place',
  amount: 'Value',
  status: 'Status'
};

export default headRowsTableMaintenances;
